<template>
  <div class="container">
    <a-form layout="inline" :form="form" @submit="handleSubmit">
      <a-row :gutter="8">
        <a-form-item label="站点名称">
          <a-input
            placeholder="请输入站点名称"
            v-decorator="['station_name']"
          />
        </a-form-item>
        <a-form-item label="报警类型">
          <a-select
            v-decorator="['alarm_type', { initialValue: '全部' }]"
            placeholder="请选择报警类型"
            style="width: 200px;"
          >
            <a-select-option
              v-for="item in allAlarmTypeList"
              :key="item.type"
              :value="item.type"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="选择日期">
          <a-range-picker
            v-decorator="[
              'time_range',
              { initialValue: [moment().subtract(10, 'days'), moment()] }
            ]"
            :allowClear="false"
            style="width: 320px"
            format="YYYY-MM-DD HH:mm"
            :show-time="{ format: 'HH: mm' }"
          />
        </a-form-item>
        <!-- <a-form-item label="报警状态">
          <a-select
            v-decorator="['alarm_status', { initialValue: '全部' }]"
            placeholder="请选择报警状态"
            style="width: 180px;"
          >
            <a-select-option
              v-for="item in statusOptions"
              :key="item.type"
              :value="item.type"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item> -->
      </a-row>
      <div style="text-align: right;margin: 8px 16px">
        <a-form-item>
          <a-button type="primary" html-type="submit" style="margin-right: 8px">
            查询
          </a-button>
          <a-button @click="resetForm" style="margin-right: 8px">
            重置
          </a-button>
          <a-button @click="exportData" type="primary" :loading="exportLoading">
            导出
          </a-button>
        </a-form-item>
      </div>
    </a-form>
    <div>
      <a-table
        :columns="columns"
        :data-source="alarmList"
        rowKey="id"
        :pagination="{
          current: page,
          total: total,
          pageSize: size,
          onChange: onPageChange
        }"
      >
        <template slot="idx" slot-scope="text, record, index">
          {{ (page - 1) * size + index + 1 }}
        </template>
        <template slot="update_log_time" slot-scope="text">
          {{ text | timeFormat }}
        </template>
        <template slot="start_log_time" slot-scope="text">
          {{ text | timeFormat }}
        </template>
        <template slot="end_log_time" slot-scope="text">
          {{ text | timeFormat }}
        </template>
        <template slot="duration" slot-scope="text, record">
          {{ durationFormat(record) }}
        </template>
        <template slot="type" slot-scope="text">
          {{ typeFormat(text) }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a @click="viewDetail(record)">查看详情</a>
        </template>
      </a-table>
    </div>
    <!-- <alarm-detail
      :visible="visible"
      :record="record"
      @cancel="v => (visible = v)"
    /> -->
    <a-modal
      :visible="visible"
      :footer="null"
      :width="600"
      :bodyStyle="{
        height: '750px',
        padding: '16px 0 8px'
      }"
      @cancel="visible = false"
    >
      <iframe width="100%" height="100%" :src="detailUrl" frameborder="0">
      </iframe>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getAlarmLogList } from "@/api/api";
// import AlarmDetail from "./components/AlarmDetail";
import { alarm_list_columns } from "@/options/columns";
import moment from "moment";
import FileSaver from "@/utils/plugins/FileSaver";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      columns: alarm_list_columns,
      alarmList: [],
      allAlarmTypeList: [],
      statusOptions: [
        { type: "全部", name: "全部" },
        { type: 0, name: "取消报警" },
        { type: 1, name: "正在报警" }
      ],
      visible: false,
      record: {},
      page: 1,
      size: 10,
      total: 0,
      detailUrl: "",
      exportLoading: false
    };
  },
  components: {
    // AlarmDetail
  },
  computed: {
    ...mapState(["authUserInfo", "alarmTypeList", "projectInfo"]),
    ...mapGetters(["defaultInfo"])
  },
  filters: {
    timeFormat(time) {
      if (!time) {
        return "";
      }
      return moment(time).format("YYYY-MM-DD HH:mm");
    }
  },
  mounted() {
    this.getAlarmLogList();
    this.allAlarmTypeList = this.$_.cloneDeep(this.alarmTypeList);
    this.allAlarmTypeList.unshift({ type: "全部", name: "全部" });
  },
  methods: {
    moment,
    durationFormat(item) {
      if (!item.start_log_time) {
        return "";
      }
      if (!item.end_log_time) {
        return "";
      }
      return moment(item.end_log_time)
        .diff(moment(item.start_log_time), "hours", true)
        .toFixed(1);
    },
    async exportData() {
      try {
        this.exportLoading = true;
        const fieldsValue = this.form.getFieldsValue();
        let station_name = fieldsValue.station_name;
        let alarm_type =
          fieldsValue.alarm_type == "全部" ? "" : fieldsValue.alarm_type;
        let alarm_start_time = moment(fieldsValue.time_range[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let alarm_end_time = moment(fieldsValue.time_range[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let alarm_status = fieldsValue.alarm_status;
        let res = await getAlarmLogList({
          group_id: this.defaultInfo.defaultGroupId,
          station_name: station_name,
          alarm_type: alarm_type,
          alarm_start_time: alarm_start_time,
          alarm_end_time: alarm_end_time,
          alarm_status: alarm_status
        });
        const resData = res.data?.items;
        if (resData?.length) {
          const header = [
            "序号",
            "站点名称",
            "数据时间",
            "开始时间",
            "结束时间",
            "持续时长",
            "报警类型",
            "报警值"
          ];
          let body = "";
          resData.forEach((item, index) => {
            body += `${index + 1},${item.station_name},${
              item.update_log_time
            }\t,${item.start_log_time}\t,${
              item.end_log_time
            }\t,${this.durationFormat(item)},${this.typeFormat(item.type)},${
              item.value
            }\n`;
          });
          const csvFlat = header.join(",") + "\n" + body;
          var blobData = new Blob([csvFlat], {
            type: "text/plain;charset=utf-8"
          });
          let fileName = "报警数据.csv";
          FileSaver.saveAs(blobData, fileName);
        } else {
          this.$message.warning("暂无数据");
        }
        this.exportLoading = false;
      } catch (error) {
        this.exportLoading = false;
        console.log(error);
      }
    },
    typeFormat(type) {
      if (!type) {
        return "";
      }
      return this.alarmTypeList.find(item => item.type == type)?.name || "";
    },
    async getAlarmLogList() {
      try {
        const fieldsValue = this.form.getFieldsValue();
        let station_name = fieldsValue.station_name;
        let alarm_type =
          fieldsValue.alarm_type == "全部" ? "" : fieldsValue.alarm_type;
        let alarm_start_time = moment(fieldsValue.time_range[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let alarm_end_time = moment(fieldsValue.time_range[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        let alarm_status = fieldsValue.alarm_status;
        let res = await getAlarmLogList({
          group_id: this.defaultInfo.defaultGroupId,
          page: this.page,
          size: this.size,
          station_name: station_name,
          alarm_type: alarm_type,
          alarm_start_time: alarm_start_time,
          alarm_end_time: alarm_end_time,
          alarm_status: alarm_status
        });
        this.alarmList = res.data.items;
        this.total = res.data.total;
      } catch (error) {
        console.log(error);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          await this.getAlarmLogList();
        }
      });
    },
    resetForm() {
      this.form.resetFields();
      const form_ = {
        alarm_type: "全部",
        time_range: [moment().subtract(10, "days"), moment()],
        alarm_status: "全部"
      };
      this.form.setFieldsValue(form_);
      this.getAlarmLogList();
    },
    onPageChange(v) {
      this.page = v;
      this.getAlarmLogList();
    },
    viewDetail(record) {
      this.visible = true;
      this.record = record;
      let host =
        process.env.NODE_ENV === "production"
          ? ""
          : process.env.VUE_APP_DETAIL_HOST;
      let start = moment(record.start_log_time).unix();
      let end = record.end_log_time
        ? moment(record.end_log_time).unix()
        : moment().unix();
      this.detailUrl =
        host +
        "/wz_station_detail/?station_id=" +
        record.station_id +
        "&group_id=" +
        this.defaultInfo.defaultGroupId +
        "&sensor_types=" +
        this.projectInfo.sensorType +
        "&data_type=" +
        record.data_type +
        "&start=" +
        start +
        "&end=" +
        end +
        "&timep=min&showMap=1";
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 10px;
}
</style>
